import React from 'react'
import { t } from 'ttag'

import { Loader } from 'components/shared/Loader/Loader'
import { Table } from 'components/shared/Table/Table'
import cx from 'classnames'
import styles from './LoaderRow.module.scss'

export const LoaderRow = ({ className }: { className?: string }) => (
  <Table.Row className={cx(styles.row, className)}>
    <Table.Cell className={styles.cell} colSpan={20} type="body">
      <span className={styles.content}>
        <Loader isInline />
        <span className={styles.text}>{t`Fetching data ...`}</span>
      </span>
    </Table.Cell>
  </Table.Row>
)
